import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "color", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import LogoTwoColor from './LogoCobrand--twoColor';
import "./logo.css";
import LogoCobrandOneColor from './LogoCobrand--oneColor';
export var LogoCobrand = function LogoCobrand(_ref) {
  var id = _ref.id,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    id: id,
    className: classNames('lm-Logo', 'lm-LogoCobrand', "lm-LogoCobrand--".concat(color), className)
  }, otherProps), color === 'inverse' ? /*#__PURE__*/React.createElement(LogoCobrandOneColor, null) : /*#__PURE__*/React.createElement(LogoTwoColor, null));
};
LogoCobrand.propTypes = {
  /** Add an optional ID to this element: `<span class="lm-Logo">`. */
  /**
    Set breakpoint value supplied by BreakpointProvider.
    @no-props
    */
  id: _pt.string,
  /**
     * Set the logo color.
     * @default 'blue'
     */
  color: _pt.oneOf(['blue', 'inverse']),
  /** Add custom classes to this element: `<span class="lm-Logo">`. */className: _pt.string
};